<template>
  <div id="app" :class="state_content_class">
      <div id="backgrounds">
        <div></div>
      </div>
      <Header v-on:reload="handleReloadContent" v-on:menu_state_changed="handleMenuStateChanged" />

      <Logo id="main-home-logo" />
      <div id="main-content-container-aple" :style="aple_style" />
      <div id="main-content-container">
        <router-view v-title="[meta.title + ' – ' + meta.blog_name]"
                     v-bind:content_text="content.text"
                     v-bind:content_title="content.title"
                     v-bind:template="content.template"
                     v-on:newImageIsLoaded="handleContentNewImageIsLoaded"/>
      </div>
      <Popup v-if="popup_on" v-bind:popup_data="popup_data" />
  </div>
</template>

<script>
    import Header from './components/Header.vue';
    import Logo from './components/Logo.vue';
    import Popup from './components/Popup.vue';
    import axios from 'axios';

    require('vue2-scrollbar/dist/style/vue2-scrollbar.css')

    const API = '/wp-json/wp/v2/pages';

    function debounce(func, wait, immediate) {
        let timeout;
        return function() {
            let context = this,
                    args = arguments;
            const later = function() {
                timeout = null;
                if (!immediate) {
                    func.apply(context, args);
                }
            };
            const callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) {
                func.apply(context, args);
            }
        };
    }

    function animShowBg(elem, time, end) {
        var step_time = 35;
        var frame_number = 1;
        var frames = time/step_time;
        var o = 0;
        var start_o = 0;
        var end_o = 1;
        function frame() {
            if (o >= 1) {
                end();
                clearInterval(id);
            } else {
                o = start_o + (((end_o - start_o) / frames) * frame_number++);
                elem.style.opacity = o;
            }
        }
        var id = setInterval(frame, step_time);
    }

    function animBoxHeight(elem, start_h, end_h, time, callback) {
        var step_time = 10;
        var frame_number = 1;
        var frames = time/step_time;
        //console.log('frames ' + frames)
        //console.log(start_h, end_h)
        var step = (end_h - start_h) / frames;
        //console.log('step ' + step)
        function frame() {
            elem.style.height = (start_h + frame_number * step) + 'px';
            //console.log(frame_number)
            if (++frame_number > frames) {
                elem.style.height = end_h + 'px';
                callback();
                clearInterval(id);
            }
        }
        var id = setInterval(frame, step_time);
    }

    export default {
        name: 'App',
        components: {
            Header,
            Logo,
            Popup,
        },
        data() {
            return {
                meta: {
                    title: window.APP_INFO.init.title,
                    blog_name: 'MOD'
                },
                actual_page_id:  window.APP_INFO.init.page_id,
                aple_style: {height: '0px'},
                state_content_class: ['none'],
                siteTitle: 'site title',
                siteDescription: '',
                popup_on: window.APP_INFO.init.popup_on,
                popup_data: window.APP_INFO.init.popup_data,
                content: {
                    title: window.APP_INFO.init.title,
                    text: window.APP_INFO.init.content,
                    template: window.APP_INFO.init.template,
                }
                };
            },
        methods: {
            goBack () {
                window.history.length > 1
                        ? this.$router.go(-1)
                        : this.$router.push('/')
            },
            resize: debounce(function() {
                let aple = document.getElementById('main-content-container-aple');
                aple.style.height = document.getElementById('main-content-container').offsetHeight + 'px';
                aple.style.display = 'block';
            }, 500),
            reloadBackgrondImage(new_url) {
                if(new_url == null) {
                    return;
                }
                var img = new Image();
                let $background_image = document.createElement('div');

                $background_image.classList.add('backgroundImage');

                img.onload = function () {
                    let $backgrounds = document.querySelector('#backgrounds');
                    $background_image.style.backgroundImage = 'url(\'' + new_url + '\')';
                    $backgrounds.appendChild($background_image);
                    animShowBg($background_image, 800, function() {
                        $backgrounds.removeChild($backgrounds.getElementsByTagName('div')[0]);
                    });
                }
                img.src = new_url;
            },
            chooseBackgroundImageUrl(images_collection) {
                if(images_collection[0] == null) {
                    return null;
                }
                const w = window.innerWidth;
                const h = window.innerHeight;
                let return_path = images_collection[images_collection.length-1]['url'];
                for (let i = 0;i<images_collection.length; i++) {
                    if (parseInt(images_collection[i]['width'], 10) >= w && parseInt(images_collection[i]['height'], 10) >= h) {
                        return_path = images_collection[i]['url'];
                        break;
                    }
                }
                return return_path;
            },
            handleContentNewImageIsLoaded(new_height) {

                this.aple_style.height = new_height + 'px';
                document.getElementById('main-content-container-aple').style.height = new_height + 'px';
            },
            handleMenuStateChanged(e){
                this.state_content_class = [
                    this.state_content_class[0],
                    this.state_content_class[1],
                    this.state_content_class[2] === '' || this.state_content_class[2] == null ? 'menu-mobile-open' : ''
                ];
            },
            handleReloadContent(page_data) {
                const vm = this;

                vm.state_content_class = [
                    vm.state_content_class[0],
                    vm.state_content_class[1],
                    ''
                ];

                if (page_data.id === vm.actual_page_id) {
                    return;
                }

                axios.get(`${API}/${page_data.id}`)
                        .then((response) => {

                vm.reloadBackgrondImage(vm.chooseBackgroundImageUrl(response.data.background_set));
                vm.actual_page_id = page_data.id;
                vm.state_content_class[0] = 'loading';
                vm.meta.title = response.data.title.rendered;                

                let aple = document.querySelector('#main-content-container-aple');

                setTimeout(function() {
                    //if(loading_status === 1) {
                    let $scroll = document.querySelector('.vue-scrollbar__area');
                    $scroll.classList.remove('vue-scrollbar-transition');
                    $scroll.style.marginTop = '0px';

                    let content = document.querySelector('#main-content-container');
                    content.style.visibility = 'hidden';
                    vm.content.template = response.data.template;
                    vm.content.text = response.data.content.rendered;
                    vm.content.title = response.data.title.rendered;

                    setTimeout(function() {
                        //aple.style.height = content.offsetHeight + 'px';

                        animBoxHeight(aple, parseInt(aple.style.height, 10), content.offsetHeight, 200, function(){
                            if(vm.actual_page_id === page_data.id) {
                                content.style.visibility = 'visible';
                                vm.state_content_class = ['static', 'page-content'];
                                setTimeout(function() {
                                    aple.style.display = 'block';
                                }, 450)
                            }
                        });

                    }, 170); // add time to rebuild vm model
                    //}
                }, 200)//100
                    //var interval_id = setInterval(function() {
                    /*setTimeout(function() {
                        //if(loading_status === 1) {
                            let $scroll = document.querySelector('.vue-scrollbar__area');
                            $scroll.classList.remove('vue-scrollbar-transition');
                            $scroll.style.marginTop = '0px';

                            let content = document.querySelector('#main-content-container');
                            content.style.visibility = 'hidden';
                            vm.content.template = response.data.template;
                            vm.content.text = response.data.content.rendered;
                            vm.content.title = response.data.title.rendered;                            
                            setTimeout(function() {
                                aple.style.height = content.offsetHeight + 'px';
                                setTimeout(function() {
                                    //show content only if is not sended new requests about another page
                                    if(vm.actual_page_id === page_data.id) {
                                        content.style.visibility = 'visible';
                                        vm.state_content_class = ['static', 'page-content'];
                                        setTimeout(function() {
                                            aple.style.display = 'block';
                                        }, 450)
                                    }
                                }, 200);
                            }, 150); // add time to rebuild vm model
                        //}
                    }, 200)//100*/

                })
                .catch((error) => {
                    console.log(error)
                });

            }
        },
    created() {
        const vm = this;
        vm.reloadBackgrondImage(vm.chooseBackgroundImageUrl(window.APP_INFO.init.background_collection));

        window.onpopstate = function() {
            if(vm.$router.history.current.path === '/') {
                window.location.href = '/';
                return;
            }
            for (let i = 0, l = APP_INFO.menu_links.length; i<l; i++) {
                if (APP_INFO.menu_links[i].url === vm.$router.history.current.path) {
                    vm.handleReloadContent({
                        href: APP_INFO.menu_links[i].url,
                        id: APP_INFO.menu_links[i].page_id
                    });
                    break;
                }
            }
        };

        window.addEventListener('resize', function(e) {
            document.getElementById('main-content-container-aple').style.display = 'none';
            vm.resize();
        });


    },
    mounted: function() {
        const vm = this;

        window.onload = function() {
            var content = document.getElementById('main-content-container');
            vm.aple_style['height'] = content.offsetHeight + 'px';
            vm.state_content_class[0] = 'init';
            vm.state_content_class[1] = vm.actual_page_id === 0 ? 'page-home' : 'page-content';
            vm.state_content_class[2] = '';

            if(vm.actual_page_id !== 0) {// show apla when page with content loaded as init page
                setTimeout(function() {
                    document.getElementById('main-content-container-aple').style.display = 'block';
                }, 500);
            }
        };
    }
    }
</script>

<style lang="scss">
    @import './assets/style.css';

    #app {
        overflow: hidden;
    }
.none #main-header ul li {
    margin-top: -4em;
}

#main-header ul li {
    transition: margin-top 0.2s, opacity 0.5s;
    margin-top: 0;
}

@for $i from 1 through 6 {
	#main-header ul li:nth-child(#{$i}) {
		transition-delay: $i * 0.05s;
	}

	h#{$i} {
	    font-size: 65px - $i * 10px;
	}
}

h1, h2, h3, h4, h5, h6 {
    font-family: 'Verdana', serif;
}

.content {
    text-align: left;
}

#main-home-logo {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);

    svg {
        width: auto;
        height: 32vh;
        max-width: 50vw;
    }
}

#nav {
    text-align: center;
    text-transform: uppercase;

  a {
      text-decoration: none;
  }
}



</style>
